function stableStringify(obj) {
    const fn = (k) => (`${JSON.stringify(k)}:${JSON.stringify(obj[k])}`);
    const sorted = Object.keys(obj).sort();
    const mapped = sorted.map(fn);
    const joined = mapped.join(',');
    return `{ ${joined} }`;
}

export function hashObject(obj) {
    const str = stableStringify(obj);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }

    return hash;
}
